import { render, staticRenderFns } from "./baseUploadNew.vue?vue&type=template&id=48c43ad7&scoped=true&"
import script from "./baseUploadNew.vue?vue&type=script&lang=js&"
export * from "./baseUploadNew.vue?vue&type=script&lang=js&"
import style0 from "./baseUploadNew.vue?vue&type=style&index=0&id=48c43ad7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c43ad7",
  null
  
)

export default component.exports